function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Caminho_935",
  "data-name": "Caminho 935",
  d: "M46.491,19.552H45.269V9.776a9.776,9.776,0,1,0-19.552,0v9.776H24.495a1.222,1.222,0,0,0,0,2.444h6.11a4.888,4.888,0,0,0,9.776,0h6.11a1.222,1.222,0,0,0,0-2.444Zm-11,4.888A2.446,2.446,0,0,1,33.049,22h4.888A2.446,2.446,0,0,1,35.493,24.44Zm4.888-4.888H28.161V9.776a7.332,7.332,0,1,1,14.664,0v9.776Z",
  transform: "translate(-23.273)"
});

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_2236",
    "data-name": "Grupo 2236",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.44,
    height: 26.884,
    viewBox: "0 0 24.44 26.884",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.f591f773.svg";
export { ForwardRef as ReactComponent };